import { Button } from '@progress/kendo-react-buttons';
import { Window } from '@progress/kendo-react-dialogs';
import { Checkbox, NumericTextBox, TextBox } from '@progress/kendo-react-inputs';
import React from 'react';
import { MessageType } from '../../services/actor-messages';
import { useFormNumericValue } from '../features/home/hooks/forms';
import { useFlightWorker } from '../hooks/use-flight-worker';
import { DropdownListWithValueField } from './inputs/DropdownListWithValueField';

export function FlightDebugger(props: { onClose?: () => void }) {
    const [selectedAction, setSelectedAction] = React.useState(0);
    const Component = actions[selectedAction];
    return (
        <Window title={'Flight debugger'} onClose={props.onClose} draggable={true} initialHeight={720} initialWidth={820}>
            <div>
                <div>Action</div>
                <DropdownListWithValueField
                    data={[
                        { value: 0, text: 'Copy route from another flight' },
                        { value: 1, text: 'Add dummy impact' },
                        { value: 2, text: 'Send custom event' }
                    ]}
                    value={selectedAction}
                    onChange={(e) => setSelectedAction(e.value)}
                />

                {Component && <Component />}
            </div>
        </Window>
    );
}

function CopyRouteAction() {
    const worker = useFlightWorker();
    const [from, setFrom] = React.useState('');
    const [to, setTo] = React.useState('');
    const [copyAtc, setCopyAtc] = React.useState(false);
    const [copyPlanned, setCopyPlanned] = React.useState(false);
    const [copyFlown, setCopyFlown] = React.useState(false);

    return (
        <div>
            <div className="d-flex pt-2 align-items-center gap-2">
                <div>From:</div>
                <TextBox value={from} onChange={(e) => setFrom(e.value as string)} />
                <div>To:</div>
                <TextBox value={to} onChange={(e) => setTo(e.value as string)} />
            </div>
            <div className="d-flex pt-2 gap-2 align-items-center">
                <div>Copy: </div>
                <Checkbox label="Atc" checked={copyAtc} onChange={(e) => setCopyAtc(e.value)} />
                <Checkbox label="Planned" checked={copyPlanned} onChange={(e) => setCopyPlanned(e.value)} />
                <Checkbox label="Flown" checked={copyFlown} onChange={(e) => setCopyFlown(e.value)} />
            </div>
            <div className="d-flex justify-content-end pt-2">
                <Button
                    themeColor="primary"
                    onClick={async () => {
                        await worker.actor.sendAsync({
                            type: MessageType.debugCopyFlightRoute,
                            data: {
                                from: +from,
                                to: +to,
                                copy: {
                                    atc: copyAtc,
                                    planned: copyPlanned,
                                    flown: copyFlown
                                }
                            }
                        });
                    }}>
                    Execute
                </Button>
            </div>
        </div>
    );
}

function SendCustomEvent() {
    const worker = useFlightWorker();
    const flightId = useFormNumericValue(0);
    const eventCode = useFormNumericValue(11572);

    return (
        <div className="d-flex flex-column gap-2 pt-2">
            <div>
                <div>Flight Id:</div>
                <NumericTextBox {...flightId} />
            </div>

            <div>
                <div>Code:</div>
                <NumericTextBox {...eventCode} />
            </div>

            <div className="d-flex justify-content-end pt-2">
                <Button
                    disabled={!flightId.value || !eventCode.value}
                    themeColor="primary"
                    onClick={async () =>
                        worker.actor.sendAsync({
                            type: MessageType.debugSendFlightEvent,
                            data: {
                                flightId: flightId.value!,
                                eventCode: eventCode.value!
                            }
                        })
                    }>
                    Execute
                </Button>
            </div>
        </div>
    );
}

const actions: Partial<Record<number, React.FC<any>>> = {
    0: CopyRouteAction,
    2: SendCustomEvent
};
